export function buildDirectionProperty(isRtl) {
    if (isRtl === true) {
        return {
            direction: 'rtl'
        };
    }
    if (isRtl === false) {
        return {
            direction: 'ltr'
        };
    }
    return {};
}
